import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";
import {AddRecordButton} from '../buttons/AddRecordButton.tsx';
// FNP-500: the hard-delete button is intentionally removed. deleteOrganizationAccount is an
// event-less hard delete that bypasses the organization-account-removed / FNP-491 projection
// contract; it is no longer reachable by console users (the mutation is @aws_iam-only). The
// modeled membership-end is deactivateOrganizationAccount, surfaced in the FNP-746 follow-up.


const useTools = () => {

    const {allowedActions} = useVerifiedPermissions()

    const tools = [<ReloadRecordsButton key='reload'/>];

    if (allowedActions.includes('CreateOrganizationAccount')) {
        tools.push(<AddRecordButton key='add'/>);
    }


    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get('Organization Accounts')}
            tools={useTools()}
        />
    );
};